import React, { useState } from 'react';
import PhotoLightbox from './PhotoLightbox';

const SubmissionPhotoGallery = ({ photos, title = "" }) => {
  const safe = (photos || []).filter(Boolean);
  const [current, setCurrent] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);

  if (!safe.length) return null;

  const go = (dir, e) => {
    e?.stopPropagation();
    setCurrent((c) => (c + dir + safe.length) % safe.length);
  };

  const openLightbox = (index = current) => {
    setCurrent(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <div className="agent-listing-media">
        <div
          className="agent-listing-cover-wrap agent-listing-gallery"
          role="button"
          tabIndex={0}
          onClick={() => openLightbox(current)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openLightbox(current); } }}
          aria-label="View photos full screen"
        >
          <img
            className="agent-listing-cover"
            src={safe[current]}
            alt={title ? `${title} — photo ${current + 1}` : ""}
            loading="lazy"
          />
          {safe.length > 1 && (
            <>
              <button type="button" className="gallery-nav prev agent-gallery-nav" onClick={(e) => go(-1, e)} aria-label="Previous photo">
                <i className="fas fa-chevron-left"></i>
              </button>
              <button type="button" className="gallery-nav next agent-gallery-nav" onClick={(e) => go(1, e)} aria-label="Next photo">
                <i className="fas fa-chevron-right"></i>
              </button>
              <span className="agent-gallery-counter">{current + 1} / {safe.length}</span>
            </>
          )}
          <button type="button" className="agent-gallery-expand" onClick={() => openLightbox(current)} title="Full screen" aria-label="Full screen">
            <i className="fas fa-expand"></i>
          </button>
        </div>
        {safe.length > 1 && (
          <div className="agent-listing-thumb-row">
            {safe.map((url, i) => (
              <button
                key={`thumb-${i}`}
                type="button"
                className={`agent-listing-thumb-link${i === current ? " active" : ""}`}
                onClick={() => setCurrent(i)}
                aria-label={`Show photo ${i + 1}`}
              >
                <img className="agent-listing-thumb" src={url} alt="" loading="lazy" />
              </button>
            ))}
          </div>
        )}
        <p className="agent-listing-photo-count">
          <i className="fas fa-images" aria-hidden="true"></i>
          {safe.length} photo{safe.length === 1 ? "" : "s"} you uploaded · click image to enlarge
        </p>
      </div>
      {lightboxOpen && (
        <PhotoLightbox photos={safe} startIndex={current} title={title} onClose={() => setLightboxOpen(false)} />
      )}
    </>
  );
};

export default SubmissionPhotoGallery;
